//#region Imports

import { Component, Injector, ViewEncapsulation, OnInit, EventEmitter, Output, Input, OnDestroy } from '@angular/core';

import * as _ from 'lodash-es';
import moment from 'moment';

import { Table } from 'primeng/table';
import { Paginator } from 'primeng/paginator';
import { LazyLoadEvent, SelectItem, MenuItem } from 'primeng/api';

import { appModuleAnimation } from '@axilla/axilla-shared';

import { AppComponentBase } from '@shared/common/app-component-base';
import { WebshopService } from '@app/shared/common/shop-system/services/webshop.service';
//#endregion Imports

@Component({
    selector: 'app-confirm-order-terms-and-conditions',
    templateUrl: './confirm-order-terms-and-conditions.component.html',
    styleUrls: ['../../../dashboard/dashboard.component.less', './confirm-order-terms-and-conditions.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class ConfirmOrderTermsAndConditionsComponent extends AppComponentBase implements OnInit, OnDestroy {

    @Input() agreements: any[];
    @Input() isRequired: boolean = false;
    @Input() readonly: boolean = false;

    @Output() acceptAgreement: EventEmitter<any> = new EventEmitter();

    constructor(
        injector: Injector,
      
        private _webshopService: WebshopService
    ) {
        super(injector);
    }


    ngOnInit(): void {


    }

    ngOnDestroy(): void {

    }

    onAcceptAgreement(agreement: any) {
        this.acceptAgreement.emit(agreement);
    }


}

